/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import channelInfo from 'cio/utils/newsletter-channel-info';
import FeaturesService from 'ember-feature-flags/services/features';
import { ChannelType } from 'cio/models/newsletter';
import TemplateModel from 'cio/models/template';
import { Editor } from 'cio/services/editor';
import { isCustomPush, isCustomPushPayloadEmpty } from 'cio/utils/push/custom-payload';

interface CioTemplateCardDetailsArgs {
  template: TemplateModel;
  translations: TemplateModel[];
}

export default class CioTemplateCardDetails extends Component<CioTemplateCardDetailsArgs> {
  @service features!: FeaturesService;

  get isTemplateTypePush() {
    return this.args.template.templateType === 'push';
  }

  get channelInfo() {
    return channelInfo(this.args.template.templateType as ChannelType);
  }

  get noContentMessage() {
    let { template } = this.args;
    return template.editor === Editor.JSON && this.isTemplateTypePush ? 'Custom payload is empty' : 'No content';
  }

  get hasContent() {
    let { template } = this.args;
    let { hasContent } = template;

    if (template.editor === Editor.SIMPLE && this.isTemplateTypePush) {
      hasContent ||= template.hasSubject;
    }

    if (isCustomPush(template)) {
      hasContent = !isCustomPushPayloadEmpty(template);
    } else if (template.editor === Editor.JSON) {
      hasContent ||= template.hasJsonContent;
    }

    return hasContent;
  }

  get mobileMessageBody() {
    if (this.args.template.templateType !== 'push') {
      return this.args.template.body ?? '';
    }

    if (this.args.template.editor === Editor.JSON && this.hasContent) {
      return 'Custom payload';
    }

    let subject = this.args.template.subject ?? '';
    let body = this.args.template.body ?? '';

    return subject ? subject : body;
  }
}
